import { render, staticRenderFns } from "./BioEditorHeader.vue?vue&type=template&id=0ba0783e&scoped=true&"
import script from "./BioEditorHeader.vue?vue&type=script&lang=js&"
export * from "./BioEditorHeader.vue?vue&type=script&lang=js&"
import style0 from "./BioEditorHeader.vue?vue&type=style&index=0&id=0ba0783e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0783e",
  null
  
)

export default component.exports